/**
 * Token Manager – Cookie-based (Phase 4)
 * Auth tokens are now HttpOnly cookies, not localStorage.
 * This manager retains only non-sensitive user caching for BC.
 * Do NOT store tokens in localStorage/sessionStorage.
 */

import { AuthToken } from '../models';

// In-memory user cache (not persisted as auth credential)
let memoryUser = null;

class TokenManager {
    // Deprecated: tokens are HttpOnly cookies, not accessible via JS
    storeToken() {
        // no-op – kept for BC, warns in dev
        if (process.env.NODE_ENV === 'development') console.warn('storeToken is deprecated – auth uses HttpOnly cookies');
    }
    getToken() {
        return null;
    }
    removeToken() {}
    storeAdminToken() {
        if (process.env.NODE_ENV === 'development') console.warn('storeAdminToken deprecated – use cookies');
    }
    getAdminToken() {
        return null;
    }
    removeAdminToken() {}
    storeOperatorToken() {
        if (process.env.NODE_ENV === 'development') console.warn('storeOperatorToken deprecated');
    }
    getOperatorToken() {
        return null;
    }
    removeOperatorToken() {}

    // User profile cache – non-sensitive, may remain in localStorage for UX but not required for auth
    storeUser(user) {
        try {
            memoryUser = user;
            // Keep localStorage for non-auth UX only if needed, but not for auth decisions
            localStorage.setItem('user', JSON.stringify(user));
        } catch {}
    }
    getUser() {
        try {
            if (memoryUser) return memoryUser;
            const raw = localStorage.getItem('user');
            return raw ? JSON.parse(raw) : null;
        } catch {
            return memoryUser;
        }
    }
    removeUser() {
        try {
            memoryUser = null;
            localStorage.removeItem('user');
        } catch {}
    }

    clearAll() {
        this.removeUser();
        // tokens are cookies – cleared server-side on logout
        if (typeof document !== 'undefined') {
            // Best-effort clear any legacy localStorage tokens
            try {
                localStorage.removeItem('token');
                localStorage.removeItem('token_expires');
                localStorage.removeItem('admin_token');
                localStorage.removeItem('operator_token');
                localStorage.removeItem('userToken');
                localStorage.removeItem('readOnlyMode');
            } catch {}
        }
    }

    isAuthenticated() {
        // Auth is now determined via backend /api/auth/verify, not token presence
        return false;
    }
    isAdminAuthenticated() {
        return false;
    }
    isOperatorAuthenticated() {
        return false;
    }
}

const tokenManager = new TokenManager();
export default tokenManager;
